// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedDepartmentLeaveSetting: null
}

const departmentLeaveSettings = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DEPARTMENT_LEAVE_SETTINGS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_DEPARTMENT_LEAVE_SETTINGS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_DEPARTMENT_LEAVE_SETTING':
      return { ...state, selectedDepartmentLeaveSetting: action.selectedDepartmentLeaveSetting }
    case 'ADD_DEPARTMENT_LEAVE_SETTING':
      return { ...state }
    case 'DELETE_DEPARTMENT_LEAVE_SETTING':
      return { ...state }
    default:
      return { ...state }
  }
}
export default departmentLeaveSettings
